<template>
	<div class="page">
		<div>
			<panelTop></panelTop>
		</div>
		<div style="margin-top:12px;display: flex;width:100%;overflow: hidden;" :style="{height:panelTableHeight+'px'}">
			<div style="position: relative;" :style="{height:panelTableHeight+'px'}">
				<div class="userBox" :class="isCollapse_userBox?'collapse':''">
					<panelUser ></panelUser>
					<panelPet style="margin-top:12px;" :style="{height:(panelTableHeight-335)+'px'}"></panelPet>
				</div>
				<img v-if="!isCollapse_userBox" style="position: absolute;right: -6px;top:300px;cursor: pointer;width:30px;"
				@click="changeIsCollapse_userBox" src="../../../assets/img/close.png" >
				<img v-if="isCollapse_userBox" style="position: absolute;z-index: 100;right: -28px;top:300px;cursor: pointer;width:38px;"
				@click="changeIsCollapse_userBox" src="../../../assets/img/open.png" >
			</div>
			<div :style="{height:panelTableHeight+'px'}" :class="['panelTable'+isCollapse,isCollapse_userBox?'collapse'+isCollapse:'']" ref="panelTable">
				<panelSale v-if="curBusiness=='消费'"></panelSale>
				<panelSaleGiftCard v-if="curBusiness=='购买礼品卡'"></panelSaleGiftCard>
				<panelXimei v-if="curBusiness=='洗美'"></panelXimei>
				<panelJiyang v-if="curBusiness=='寄养'"></panelJiyang>
				<panelGuahao v-if="curBusiness=='挂号'"></panelGuahao>
				
				<panelBingli v-if="curBusiness=='病例记录'"></panelBingli>
				<panelYmcq v-if="curBusiness=='免疫'"></panelYmcq>
				<panelYmcq v-if="curBusiness=='免疫记录'"></panelYmcq>
				<panelZhuyuan v-if="curBusiness=='住院记录'"></panelZhuyuan>
				<panelSaleRecord v-if="curBusiness=='消费记录'"></panelSaleRecord>
				
				<panelActivity v-if="curBusiness=='活动'"></panelActivity>
				<panelLiving v-if="curBusiness=='活体'"></panelLiving>
				
				<panelJiedai v-if="curBusiness=='接待'"></panelJiedai>
				<panelGenjin v-if="curBusiness=='跟进'"></panelGenjin>
				<panelYuyue v-if="curBusiness=='预约'"></panelYuyue>
				<panelJihua v-if="curBusiness=='调拨单'"></panelJihua>
				<panelUnpay2 v-if="curBusiness=='2小时'"></panelUnpay2>
				
				<panelHuifang v-if="curBusiness=='回访记录'"></panelHuifang>
				<panelRecharge v-if="curBusiness=='充值记录'||curBusiness=='充值'"></panelRecharge>
				<panelYajin v-if="curBusiness=='押金'"></panelYajin>
				<panelXizaoka v-if="curBusiness=='洗美卡'"></panelXizaoka>
				<panelGiftCard v-if="curBusiness=='礼品卡'"></panelGiftCard>
				<panelDiscount v-if="curBusiness=='优惠券'"></panelDiscount>
				<panelJifen v-if="curBusiness=='积分'"></panelJifen>
				<panelVipPower v-if="curBusiness=='会员权益'"></panelVipPower>
				<ing v-if="curBusiness=='ing'"></ing>
			</div>
		</div>
	</div>
</template>
<script>
	import panelUser from "./panel_user.vue"
	import panelTop from "./panel_top.vue"
	import panelPet from "./panel_pet.vue"
	import panelSale from "./panel_sale.vue"
	import panelSaleGiftCard from "./panel_sale_giftCard.vue"
	import panelJiyang from "./panel_jiyang.vue"
	import panelXimei from "./panel_ximei.vue"
	import panelGuahao from "./panel_guahao.vue"
	import panelBingli from "./panel_bingli.vue"
	import panelYmcq from "./panel_ymcq.vue"
	import panelActivity from "./panel_activity.vue"
	import panelLiving from "./panel_living.vue"
	import panelGenjin from "./panel_genjin.vue"
	import panelJiedai from "./panel_jiedai.vue"
	import panelYuyue from "./panel_yuyue.vue"
	import panelJihua from "./panel_jihua.vue"
	import panelUnpay2 from "./panel_unpay2.vue"
	import panelZhuyuan from "./panel_zhuyuan.vue"
	import panelSaleRecord from "./panel_saleRecord.vue"
	
	import panelHuifang from "./panel_huifang.vue"
	import panelRecharge from "./panel_recharge.vue"
	import panelYajin from "./panel_yajin.vue"
	import panelXizaoka from "./panel_xizaoka.vue"
	import panelGiftCard from "./panel_giftCard.vue"
	// import panelVipPower from "./panel_vipPower.vue"
	import panelDiscount from "./panel_discount.vue"
	import panelJifen from "./panel_jifen.vue"
	import ing from "./panel_ing.vue"
	export default {
		components:{panelVipPower: () => import('./panel_vipPower.vue'),panelUser,panelTop,panelPet,panelSale,panelSaleGiftCard,panelJiyang,panelXimei,panelGuahao,panelJiedai,panelBingli,panelYmcq,panelActivity,panelLiving,panelGenjin,panelYuyue,panelJihua,panelUnpay2,panelZhuyuan,panelSaleRecord,panelHuifang,panelRecharge,panelYajin,panelXizaoka,panelGiftCard,panelDiscount,panelJifen,ing},
		data(){
			return{
				isCollapse_userBox:false,
				panelTableHeight:'700',
				isCollapse:0, 
				// 新建洗美预约
				userId:'',
				petId:''
			}
		},
		computed:{
			// isCollapse(){
			// 	return this.$store.state.mendian.isCollapse;
			// },
			
			curBusiness(){
				return this.$store.state.mendian.curBusiness;
			}
		},
		watch:{
			// isCollapse(n){
			// 	console.log(n)
			// }
		},
		mounted(){
			
			
			
			this.$nextTick(()=>{
				// this.panelTableHeight = document.documentElement.clientHeight-this.$refs.panelTable.getBoundingClientRect().top;
				this.panelTableHeight = document.documentElement.clientHeight-132;
			})
		},
		methods: {
			changeIsCollapse_userBox(){
				this.isCollapse_userBox = !this.isCollapse_userBox;
			}
		}
	}
</script>
<style scoped lang="scss">
.page{
	position: relative;
	height: 100%;
	.userBox{
		width:252px;border-right: 12px solid #f5f5f5;transition: all .3s ease-in-out;overflow-x: hidden;height: 100%;display: flex;flex-direction: column;
		&.collapse{
			width:0px;
			border-right: 0px solid #f5f5f5;
		}
		&::-webkit-scrollbar {
			width: 4px;
			// height: 4px;
		}
	}
	.panelTable0{
		position: relative;
		// width:975px;
		width: calc(100% - 264px);
		transition: all .3s ease-in-out;
		&.collapse0{
			width:100%;
		}
	}
	.panelTable1{
		position: relative;
		width:975px;
		transition: all .3s ease-in-out;
		&.collapse1{
			width:1839px;
		}
	}
}
</style>
